import { render, staticRenderFns } from "./WriteOff.vue?vue&type=template&id=467c1b1b&scoped=true"
import script from "./WriteOff.vue?vue&type=script&lang=js"
export * from "./WriteOff.vue?vue&type=script&lang=js"
import style0 from "./WriteOff.vue?vue&type=style&index=0&id=467c1b1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467c1b1b",
  null
  
)

export default component.exports